import { inject, Injectable } from '@angular/core'
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap'
import { UserOffcanvasComponent } from './user-offcanvas.component'
import { Me } from '../../../core/interfaces/me/me.interface'
import { CompanyDetails } from '../../../core/interfaces/company/company-details.interface'

@Injectable({
    providedIn: 'root',
})
export class UserOffcanvasService {
    #offcanvasService = inject(NgbOffcanvas)

    open(me: Me | null, company: CompanyDetails | null): void {
        const offcanvasRef = this.#offcanvasService.open(UserOffcanvasComponent, {
            position: 'end',
            panelClass: 'user-offcanvas-panel',
        })
        offcanvasRef.componentInstance.me = me
        offcanvasRef.componentInstance.company = company
    }
}
